import { render, staticRenderFns } from "./MappingRelationship.vue?vue&type=template&id=42eaa900&"
import script from "./MappingRelationship.vue?vue&type=script&lang=js&"
export * from "./MappingRelationship.vue?vue&type=script&lang=js&"
import style0 from "./MappingRelationship.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports